import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, exhaustMap, catchError, tap } from 'rxjs/operators';
import { CatalogoService } from '../../../modules/home/services/catalogos.service';
import * as CatalogoActions from './catalogo.actions';
import { Toast } from '../../configs/toast';

@Injectable()
export class CatalogoEffects {

  private actions$ = inject(Actions);
  private catalogoService = inject(CatalogoService);

  foundPaises$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(CatalogoActions.searchPaises),
        exhaustMap( async() => {
            const paises = await this.catalogoService.getCatalogoPaises()
            if(paises){
                return CatalogoActions.foundPaises({data: paises})
            }else{
                return CatalogoActions.errorGetCatalogo()
            }
        })
    );
  })

  foundEstados$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(CatalogoActions.searchEstados),
        exhaustMap( async( action ) => {
            const estados = await this.catalogoService.getCatalogoEstados(action.pais)
            if(estados){
                return CatalogoActions.foundEstados({data: estados})
            }else{
                return CatalogoActions.errorGetCatalogo()
            }
        })
    );
  })

  foundMunicipios$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(CatalogoActions.searchMunicipios),
        exhaustMap( async ( action ) => {
            const municipios = await this.catalogoService.getCatalogoMunicipio(action.estado)
            if(municipios){
                return CatalogoActions.foundMunicipios({data: municipios})
            }else{
                return CatalogoActions.errorGetCatalogo()
            }
        })
    );
  })

  foundCodigosPostales$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(CatalogoActions.searchCodigosPostales),
        exhaustMap( async ( action ) => {
            const codigosPostales = await this.catalogoService.getCodigosPostales(action.municipio)
            if(codigosPostales){
                return CatalogoActions.foundCodigosPostales({data: codigosPostales})
            }else{
                return CatalogoActions.errorGetCatalogo()
            }
        })
    );
  })

  foundColonias$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(CatalogoActions.searchColonias),
        exhaustMap( async ( action ) => {
            const colonias = await this.catalogoService.getCatalogoColonias(action.codigoPostal)
            if(colonias){
                return CatalogoActions.foundColonias({data: colonias})
            }else{
                return CatalogoActions.errorGetCatalogo()
            }
        })
    );
  })

  $SendMessageError = createEffect(() => this.actions$.pipe(
        ofType(CatalogoActions.errorGetCatalogo),
        tap(() => {
            Toast.fire('Error al cargar el catalogo', 'Favor de contactar a soporte, rmendoza@grupodaytona.com', 'error')
        }),
        map(() => ({ type: 'NO_ACTION' }))
    ), { dispatch: false })

  
}